export function CopyPasteWebkit (pEditor, pCopyPaste)
{
  var saveCopyPasteRangeStructure;
  
  
  this.webkitCutCopyPaste = (pButton, command) =>
  {
    pEditor.onlykeyCutCopyPaste(null, command);
  };


  this.webkitCopy = (e) =>
  {
    BEditor.webkitCopy(e, pEditor.iFrame);
  };


  this.webkitPaste = (e) =>
  {
    var i,
        currentSelection,
        currentRange,
        pasteContainer,
        webKitClipboard,
        pointRange,
        pointElement,
        currentRangeCoords,
        htmlClipboardIndex = null,
        plainClipboardIndex = null;

    if (!(e && e.clipboardData && e.clipboardData.items && e.clipboardData.items.length))
    {
      return false;
    }

    pEditor.contentChecker.isStopCheckContentChanged = true;
    pEditor.undoRedo.isStopSaveUndo = true;
    pEditor.contentChecker.isPasteEvent = 1;

    BEditor.EditorsManager.showPageShadingContainer(true, 'Cleaning HTML...', 1000);

    if (BEditor.isWebKitClipboard)
    {
      if(webkitPasteDo())
      {
        BEditor.domHandlers.stopEvent(e);
        return false;
      }
    }
    else
    {
      currentSelection = pEditor.range.selection.getCurrent();
      currentRange = pEditor.range.getCurrent();
      webKitClipboard = (window.localStorage && window.localStorage['webKitClipboard'] != null) ? window.localStorage['webKitClipboard'] : BEditor['webKitClipboard'];

      if (e && e.clipboardData && e.clipboardData.items && currentSelection && currentRange)
      {
        for (i = 0; i < e.clipboardData.items.length; i++)
        {
          if (e.clipboardData.items[i].type === 'text/plain' && e.clipboardData.items[i].kind === 'string')
          {
            plainClipboardIndex = i;
          }

          if (e.clipboardData.items[i].type === 'text/html' && e.clipboardData.items[i].kind === 'string')
          {
            htmlClipboardIndex = i;
          }
        }

        if (plainClipboardIndex !== null || (htmlClipboardIndex !== null && htmlClipboardIndex !== 0))
        {
          i = (htmlClipboardIndex !== null) ? htmlClipboardIndex : plainClipboardIndex;

          if (currentRange.collapsed)
          {
            pointElement = pEditor.iFrameDoc.createElement('ABBR');
            pointRange = currentRange.cloneRange();
            pointRange.collapse(true);
            pointRange.insertNode(pointElement);

            if (pointElement.parentNode.nodeName === 'BODY')
            {
              if (pointElement.previousElementSibling && pointElement.previousElementSibling.nodeName === 'P' && (/\s*<br(?:\s[^>]*>|>)\s*/).test(pointElement.previousElementSibling.innerHTML))
              {
                pointElement.previousElementSibling.insertAdjacentElement('afterbegin', pointElement);
              }
              else if (pointElement.nextElementSibling && pointElement.nextElementSibling.nodeName === 'P' && (/\s*<br(?:\s[^>]*>|>)\s*/).test(pointElement.nextElementSibling.innerHTML))
              {
                pointElement.nextElementSibling.insertAdjacentElement('afterbegin', pointElement);
              }
            }

            currentRangeCoords = BEditor.dimensions.getElementXY(pointElement);
            pointElement.parentNode.removeChild(pointElement);
          }
          else
          {
            currentRangeCoords = currentRange.getBoundingClientRect();
          }

          saveCopyPasteRangeStructure =
          {
            'startContainer': currentRange.startContainer,
            'startOffset': currentRange.startOffset,
            'endContainer': currentRange.endContainer,
            'endOffset': currentRange.endOffset
          };

          pasteContainer = pEditor.iFrameDoc.createElement(((htmlClipboardIndex !== null) ? 'DIV' : 'TEXTAREA'));
          pasteContainer.setAttribute('style', 'position: absolute; left: ' + Math.floor(currentRangeCoords.left) + 'px; top: ' + Math.floor(currentRangeCoords.top) + 'px; width: 1px; height: 1px; overflow: hidden; opacity: 0;');
          pasteContainer.setAttribute('data-wawebkitpastecontainer', '1');
          pEditor.iFrameDoc.body.appendChild(pasteContainer);

          if (htmlClipboardIndex !== null)
          {
            currentRange.selectNodeContents(pasteContainer);
            currentSelection.removeAllRanges();
            currentSelection.addRange(currentRange);
          }
          else
          {
            pEditor.iFrameDoc.designMode = 'off';
            pasteContainer.focus();
          }

          e.clipboardData.items[i].getAsString(webkitPasteWait);

          return true;
        }
      }
    }

    pCopyPaste.removeWebkitCopyMarker();
    pCopyPaste.removeSystemComponents();
    pEditor.helpers.restoreEditorEntities();
    pEditor.undoRedo.isStopSaveUndo = false;
    pEditor.contentChecker.isStopCheckContentChanged = false;
    pEditor.contentChecker.isPasteEvent = 0;
    BEditor.EditorsManager.hidePageShadingContainer();
  };


  function webkitPasteWait (pasteContent)
  {
    setTimeout(function () { webkitPasteDo(pasteContent); }, 10);
  }


  function webkitPasteDo (pasteContent)
  {
    var i,
        blockTags = /<(?:ADDRESS|AUDIO|BLOCKQUOTE|CENTER|DIV|DIR|DL|FIELDSET|FIGURE|FORM|H[1-6]|HR|ISINDEX|MENU|OL|P|PRE|TABLE|UL|VIDEO)[\s>]/i,
        containerTags = /^(?:BLOCKQUOTE|CENTER|DIV|FIELDSET|FIGURE|FORM|LI|TH|TD)$/i,
        styleTags = /^(?:B|BDO|BIG|EM|FONT|I|S|SMALL|SPAN|STRIKE|STRONG|SUB|SUP|U)$/i,
        reInsertBeforeParagraph = /^<[^>]+>\s*<abbr[^>]+data-wawebkitcopyendpointer[^>]+>\s*&nbsp;\s*<\/abbr>/i,
        reInsertAfterParagraph = /<abbr[^>]+data-wawebkitcopyendpointer[^>]+>\s*&nbsp;\s*<\/abbr>\s*<\/[^>]+>/i,
        waWebKitCopyEndPointer = '<abbr data-wawebkitcopyendpointer="1">&nbsp;</abbr>',
        rePasteContent = /<!--\s*StartFragment\s*-->([\S\s]*?)<!--\s*EndFragment\s*-->/i,
        copyEndPointer,
        pasteContainers = pEditor.iFrameDoc.body.querySelectorAll('[data-wawebkitpastecontainer]'),
        pasteContainer,
        copyMarker,
        isLocalCopy = false,
        isPlainText = false,
        timeStamp = null,
        parentElement,
        prevParentElement,
        topParentElement,
        currentParentElement,
        strIndex,
        subStr,
        parentParts = [],
        parentsBegin = '',
        parentsEnd = '',
        parentElementHTML,
        webKitClipboard,
        webkitCopyParentsBegin = '',
        webkitCopyParentsEnd = '',
        isAddParentBeginEnd = false,
        rawHTML,
        simplifyFormattingRet,
        webkitCopyHTML,
        webkitCopyResultHTML,
        currentSelection = pEditor.range.selection.getCurrent() || pEditor.iFrame.getSelection(),
        currentRange = pEditor.range.getCurrent() || pEditor.iFrameDoc.createRange(),
        currentRangeHTML,
        outerParentTags = [];

    if (BEditor.isWebKitClipboard || pasteContainers)
    {
      if (BEditor.isWebKitClipboard)
      {
        webKitClipboard = (window.localStorage && window.localStorage['webKitClipboard'] != null) ? window.localStorage['webKitClipboard'] : BEditor['webKitClipboard'];

        if (webKitClipboard)
        {
          webKitClipboard = JSON.parse(webKitClipboard);
          getWebkitCopyData();
          isLocalCopy = true;
        }
      }
      else
      {
        if (pasteContainers.length === 0)
        {
          if (rePasteContent.test(pasteContent))
          {
            pasteContainer = pEditor.iFrameDoc.createElement('DIV');
            pasteContainer.setAttribute('style', 'position: absolute; left: 0; top: 0; width: 1px; height: 1px; overflow: hidden; opacity: 0;');
            pasteContainer.setAttribute('data-wawebkitpastecontainer', '1');
            pasteContainer.innerHTML = pasteContent.replace(rePasteContent, '$1');
            pEditor.iFrameDoc.body.appendChild(pasteContainer);
          }
          else
          {
            return false;
          }
        }
        else
        {
          pasteContainer = pasteContainers[pasteContainers.length - 1];
        }

        if (pasteContainer.nodeName === 'TEXTAREA')
        {
          pEditor.iFrameDoc.designMode = 'on';
          pEditor.pThis.focus();
          webkitCopyHTML = pCopyPaste.convertPastePlainText(pasteContainer.value);
          isPlainText = true;
        }
        else
        {
          if (pasteContainer && 'querySelector' in pasteContainer && typeof(pasteContainer.querySelector) === 'function')
          {
            copyMarker = pasteContainer.querySelector('ABBR[data-wawebkitcopymarker]');
          }

          if (copyMarker)
          {
            timeStamp = copyMarker.getAttribute('data-wawebkitcopymarker');
            pCopyPaste.removeWebkitCopyMarker();
            webKitClipboard = (window.localStorage && window.localStorage['webKitClipboard'] != null) ? window.localStorage['webKitClipboard'] : BEditor['webKitClipboard'];

            if (webKitClipboard)
            {
              webKitClipboard = JSON.parse(webKitClipboard);

              if (webKitClipboard['timeStamp'] == timeStamp)
              {
                getWebkitCopyData();
                isLocalCopy = true;
              }
            }
          }

          if (webkitCopyHTML == null && pasteContainer && pasteContainer.innerHTML)
          {
            rawHTML = pasteContainer.innerHTML;
            simplifyFormattingRet = pCopyPaste.normalizer.normalize(rawHTML, {'isClearEmptyTags': true});
            webkitCopyHTML = simplifyFormattingRet.htmlContent;
          }
        }
      }

      pCopyPaste.removePasteContainers();

      if (!BEditor.isWebKitClipboard && currentSelection && currentRange && currentRange.setStart && currentRange.setEnd)
      {
        currentRange.setStart(saveCopyPasteRangeStructure.startContainer, saveCopyPasteRangeStructure.startOffset);
        currentRange.setEnd(saveCopyPasteRangeStructure.endContainer, saveCopyPasteRangeStructure.endOffset);
        currentSelection.removeAllRanges();
        currentSelection.addRange(currentRange);
      }

      currentRange = pEditor.range.getCurrent();

      if (webkitCopyHTML && currentRange)
      {
        parentElement = currentRange.commonAncestorContainer;

        while (parentElement && parentElement.nodeType !== 1)
        {
          parentElement = parentElement.parentNode;
        }

        if (parentElement.nodeName === 'TD' && (/^\s*&nbsp;\s*$/i).test(parentElement.innerHTML))
        {
          currentRange.selectNodeContents(parentElement);
          currentSelection.removeAllRanges();
          currentSelection.addRange(currentRange);
        }

        currentRangeHTML = pEditor.range.content.getHTML();

        if (parentElement && (parentElement.innerHTML === '' || (currentRangeHTML && parentElement.innerHTML === currentRangeHTML)))
        {
          prevParentElement = parentElement;

          do
          {
            outerParentTags.push((prevParentElement.outerHTML.replace(/^(<[^>]+>)[\S\s]*/, '$1')).toUpperCase());
            currentParentElement = prevParentElement;
            prevParentElement = currentParentElement.parentNode;
          }
          while (prevParentElement && styleTags.test(prevParentElement.nodeName) && prevParentElement.innerHTML === currentParentElement.outerHTML);
        }

        webkitCopyResultHTML = webkitCopyParentsBegin + webkitCopyHTML + webkitCopyParentsEnd;

        webkitCopyResultHTML = webkitCopyResultHTML.replace(/^(?:\s*<[^>]+>\s*)+/, function (tags)
        {
          let isContinue = true;

          tags = tags.replace(/\s*<[^>]+>\s*/g, function (tag)
          {
            let i,
                cmpTag = tag.toUpperCase();

            if (isContinue)
            {
              for (i = outerParentTags.length; i--;)
              {
                if (cmpTag === outerParentTags[i])
                {
                  tag = tag.substr(0, tag.length - 1) + ' data-wawebkitdoubletagindex="' + i + '"' + tag.substr(tag.length - 1);
                  return tag;
                }
              }
            }

            isContinue = false;
            return tag;
          });

          return tags;
        });

        currentRange.deleteContents();
        pEditor.contentCleaner.removeEmptyP();
        currentRange.insertNode(currentRange.createContextualFragment(waWebKitCopyEndPointer));
        copyEndPointer = pEditor.iFrameDoc.body.querySelector('ABBR[data-wawebkitcopyendpointer]');

        if(copyEndPointer)
        {
          if (blockTags.test(webkitCopyResultHTML) && parentElement && parentElement.nodeName !== 'BODY' && !containerTags.test(parentElement.nodeName))
          {
            prevParentElement = parentElement;

            while (prevParentElement && prevParentElement.nodeName !== 'BODY' && !containerTags.test(prevParentElement.nodeName))
            {
              parentParts[0] = prevParentElement.outerHTML;
              subStr = '>' + prevParentElement.innerHTML + '<';
              strIndex = parentParts[0].lastIndexOf(subStr);

              if (strIndex !== -1)
              {
                parentParts[1] = parentParts[0].substring(0, strIndex + 1);
                parentParts[2] = parentParts[0].substring(strIndex + subStr.length - 1);
              }
              else
              {
                parentParts = parentParts[0].match(/^(<[^>]+>).*?(<[^>]+>)$/);
              }

              if (parentParts && parentParts.length === 3)
              {
                parentsBegin = parentParts[1] + parentsBegin;
                parentsEnd += parentParts[2];
              }

              topParentElement = prevParentElement;
              prevParentElement = prevParentElement.parentNode;
            }

            parentElementHTML = parentElement.outerHTML;

            if (reInsertBeforeParagraph.test(parentElementHTML))
            {
              parentElement.parentNode.insertBefore(copyEndPointer, parentElement);
            }
            else if (reInsertAfterParagraph.test(parentElementHTML))
            {
              parentElement.parentNode.insertBefore(copyEndPointer, parentElement.nextSibling);
            }
            else
            {
              isAddParentBeginEnd = true;
            }
          }

          if (rawHTML != null && simplifyFormattingRet.isSimplify)
          {
            if (pEditor.style.normalizer.checkMsHTML(rawHTML))
            {
              rawHTML = pEditor.style.normalizer.clearMsHTML(rawHTML);
            }

            rawHTML = pEditor.iFrameDoc.body.innerHTML.replace(/<abbr[^>]+data-wawebkitcopyendpointer[^>]+>\s*&nbsp;\s*<\/abbr>/i, (isAddParentBeginEnd ? parentsEnd + rawHTML + parentsBegin : rawHTML));
            //pEditor.undoRedo.saveUndoDo(false, rawHTML);
            pCopyPaste.showAutoCleaningMessage();
          }

          if (isAddParentBeginEnd)
          {
            if (topParentElement && topParentElement.parentNode)
            {
              topParentElement.outerHTML = topParentElement.outerHTML.replace(/<abbr[^>]+data-wawebkitcopyendpointer[^>]+>\s*&nbsp;\s*<\/abbr>/i, parentsEnd + webkitCopyResultHTML + parentsBegin + waWebKitCopyEndPointer);
            }
            else
            {
              copyEndPointer.outerHTML = parentsEnd + webkitCopyResultHTML + parentsBegin + waWebKitCopyEndPointer;
            }
          }
          else
          {
            copyEndPointer.insertAdjacentHTML('beforebegin', webkitCopyResultHTML);
          }
        }

        removeDoubleTags();

        if (!isLocalCopy && !isPlainText)
        {
          setTimeout(() => pEditor.contentChecker.onPasteHandler(setCursorPointer), 100);
        }
        else
        {
          pCopyPaste.removeSystemComponents();
          pEditor.helpers.restoreEditorEntities();
          setCursorPointer(true);
          setTimeout(setCursorPointer, 500);
          pEditor.contentChecker.afterClearCallBack = setCursorPointer;
          pEditor.undoRedo.isStopSaveUndo = false;
          pEditor.contentChecker.isStopCheckContentChanged = false;
          pEditor.contentChecker.isPasteEvent = 0;
          BEditor.EditorsManager.hidePageShadingContainer();
        }

        return true;
      }

      pCopyPaste.removeWebkitCopyMarker();
      pCopyPaste.removeSystemComponents();
      pEditor.helpers.restoreEditorEntities();
      pEditor.undoRedo.isStopSaveUndo = false;
      pEditor.contentChecker.isStopCheckContentChanged = false;
      pEditor.contentChecker.isPasteEvent = 0;
      BEditor.EditorsManager.hidePageShadingContainer();
    }

    pEditor.undoRedo.isStopSaveUndo = false;
    pEditor.contentChecker.isStopCheckContentChanged = false;
    pEditor.contentChecker.isPasteEvent = 0;
    BEditor.EditorsManager.hidePageShadingContainer();

    function getWebkitCopyData ()
    {
      webkitCopyParentsBegin = webKitClipboard['parentsBegin'] || '';
      webkitCopyParentsEnd = webKitClipboard['parentsEnd'] || '';
      webkitCopyHTML = webKitClipboard['HTML'] || '';
    }

    function setCursorPointer (isNotRemove)
    {
      let i,
          elements,
          element = pEditor.iFrameDoc.body.querySelector('ABBR[data-wawebkitcopyendpointer]');

      pEditor.contentChecker.afterClearCallBack = null;

      if (element)
      {
        currentSelection.removeAllRanges();
        currentRange.setEndBefore(element);
        currentRange.setStartBefore(element);
        currentSelection.addRange(currentRange);
      }

      if (!isNotRemove)
      {
        elements = pEditor.iFrameDoc.body.querySelectorAll('ABBR[data-wawebkitcopyendpointer]');

        for (i = elements.length; i--;)
        {
          if (elements[i] && elements[i].parentNode)
          {
            elements[i].parentNode.removeChild(elements[i]);
          }
        }
      }
    }

    function removeDoubleTags ()
    {
      let i,
          elements = pEditor.iFrameDoc.body.querySelectorAll('[data-wawebkitdoubletagindex]');

      for (i = elements.length; i--;)
      {
        if (elements[i] && elements[i].parentNode)
        {
          elements[i].outerHTML = elements[i].innerHTML;
        }
      }

      elements = pEditor.iFrameDoc.body.querySelectorAll('[data-wawebkitdoubletagindex]');

      for (i = elements.length; i--;)
      {
        elements[i].removeAttribute('data-wawebkitdoubletagindex');
      }
    }
  }
}